// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://services.ravel.faith/api',
  basePath: 'http://services.ravel.faith/',
  socketUrl: 'http://services.ravel.faith',
  profileUrl: "http://services.ravel.faith/#/profile/",
  merchantProfileUrl:"https://services.ravel.faith/merchant/#",

  // basePath: 'http://localhost:9000/',
  // baseUrl: 'http://localhost:9000/api',
  // socketUrl: 'http://localhost:9000',
  // profileUrl: "http://localhost:9000/#/profile/",
  // merchantProfileUrl: "http://localhost:9000/merchant/#",



  // baseUrl: 'http://stage-api.ravel.faith/api',
  // basePath: 'http://stage-api.ravel.faith/',
  facebookId: '',
  googleId: '',
  firebase: {
    apiKey: "AIzaSyDfZeCGzTlVfOW1M826Vi3-xAt89ji5g0A",
    authDomain: "ravel-merchant.firebaseapp.com",
    projectId: "ravel-merchant",
    storageBucket: "ravel-merchant.appspot.com",
    messagingSenderId: "211703403861",
    appId: "1:211703403861:web:d64fd99a109efd8ec48bdc",
  },
  // socketUrl: 'http://stage-api.ravel.faith',
  errorMessage: 'Required',
  // profileUrl: "http://localhost:4200/profile/",
  // profileUrl: "http://stage-personal.ravel.faith/#/my-business/merchant/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
